import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { configureStore } from './redux/store';
import reportWebVitals from './reportWebVitals';

const App = React.lazy(() => import(/* webpackChunkName: "App" */ './App'));

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    console.error('Application Error:', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error details:', error, errorInfo);

    // Log chunk loading errors but don't auto-reload (prevents infinite loops)
    if (error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk')) {
      console.error('ChunkLoadError detected. Please refresh the page manually (Ctrl+F5).');
    }
  }

  render() {
    if (this.state.hasError) {
      return <div className="loading" />;
    }
    return this.props.children;
  }
}

const Main = () => {
  return (
    <ErrorBoundary>
      <Provider store={configureStore()}>
        <Suspense fallback={<div className="loading" />}>
          <App />
        </Suspense>
      </Provider>
    </ErrorBoundary>
  );
};

ReactDOM.render(<Main />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
